var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGgStatusInfoBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.999,
    height: 12.215,
    viewBox: "0 0 11.999 12.215",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_14313",
    "data-name": "\\uADF8\\uB8F9 14313",
    transform: "translate(-1062 -245)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5844",
    "data-name": "\\uD328\\uC2A4 5844",
    d: "M11.1,9.5V21.715h1.806v-2.29h2.224v2.29h1.806V9.5Zm3.452,1.166h1.258v1.243H14.552Zm-.007,2.1h1.265V14H14.545Zm-2.363-2.089h1.244v1.243H12.182Zm1.258,2.089V14H12.189V12.762Zm-1.251,2.089h1.244V16.1H12.189ZM13.482,18.2H12.238v-1.25h1.244Zm1.063-3.36H15.8v1.257H14.545Zm1.3,3.353H14.594V16.933h1.251Z",
    transform: "translate(1050.9 235.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5845",
    "data-name": "\\uD328\\uC2A4 5845",
    d: "M99,62.2v8.547h5.925V62.2Zm3.5,1.111h1.3l.007,1.22h-1.3Zm-2.363.007h1.281l.007,1.22h-1.281Zm1.3,5.423h-1.281l-.007-1.227h1.281Zm0-2.105h-1.281l-.007-1.22h1.281Zm2.363,2.1h-1.288L102.5,67.5h1.288Zm.007-2.1h-1.3l-.007-1.22h1.3Z",
    transform: "translate(969.074 186.42)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGgStatusInfoBuilding);
export default __webpack_public_path__ + "static/media/gg_statusInfo_building.7f40c1e9aeb16afbaade3a5ff4c90ef5.svg";
export { ForwardRef as ReactComponent };